import './lbaRadio.scss';

const $inject = [];

const lbaRadio = function () {
    return {
        restrict: 'A',
        scope: {
            settings: '<'
        },
        bindToController: true,
        controller: 'lbaRadioCtrl',
        controllerAs: 'vm',
        template: require('./lbaRadio.html')
    };
};

lbaRadio.$inject = $inject;

export default lbaRadio;



// WEBPACK FOOTER //
// ./src/components/lbaRadio/lbaRadioDir.js